// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1FJCP","title":"Images45_title__wLaD6","images":"Images45_images__UkehK"};